export default "__VITE_ASSET__DfBHA8fC__"